import parse from "html-react-parser";
import BaseModal from "./Modals/BaseModal";
import { useRef, useState } from "react";
import React from "react";
import JournalShareModal from "./JournalShareModal";

const ViewMemoryModal = ({
  open,
  memory,
  loading,
  handleRefresh,
  onClose,
  openFullMemoryModal,
}) => {
  const modalRef1 = useRef(null);
  const [isFullMemoryModalOpen, setIsFullMemoryModalOpen] = useState(false);
  const [titleToShare, setTitleToShare] = useState("Share your Memory Summary");
  const [showJournalShareModal, setShowJournalShareModal] = useState(false);

  function formatDateWithOrdinal(dateString) {
    if (!dateString) return "";
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "long" });
    const year = date.getFullYear();
    const getOrdinal = (n) => {
      const s = ["th", "st", "nd", "rd"],
        v = n % 100;
      return n + (s[(v - 20) % 10] || s[v] || s[0]);
    };
    return `${month} ${getOrdinal(day)},${year}`;
  }

  const handleGenerateAndShare = async () => {
    setShowJournalShareModal(true);
    setTitleToShare(memory?.emotion_name ?? "Share your Memory Summary");
    setIsFullMemoryModalOpen(false);
  };

  const handleJournalShareModalClose = () => {
    setShowJournalShareModal(false);
    setTitleToShare("");
  };

  if (!open) return null;

  return (
    <>
      {!isFullMemoryModalOpen && (
        <BaseModal open={open} onClose={onClose} title="My Memory" width={640}>
          <div ref={modalRef1}>
            <div className="memory-modal-subtitle d-flex justify-content-between">
              <div className="meta-info d-flex gap-2 align-items-center">
                <img src="/icons/discover.svg" alt="" />
                <span className="text-body-b1">
                  {memory?.emotion_name} Stack
                </span>
              </div>
              <div className="meta-info d-flex gap-2 align-items-center">
                <span className="text-body-b3">
                  {formatDateWithOrdinal(memory?.created_at)}
                </span>
                <img
                  src="/icons/rotate-right.svg"
                  alt=""
                  onClick={handleRefresh}
                  style={{ cursor: "pointer" }}
                />
              </div>
            </div>
            <div
              className="memory-modal-body position-relative"
              style={{ marginTop: 16 }}
            >
              {loading ? (
                <div className="text-center py-5">
                  <div className="loader-container">
                    <div className="loader" />
                  </div>
                </div>
              ) : memory &&
                memory.answers &&
                Object.values(memory.answers).some(
                  (section) => Array.isArray(section) && section.length > 0,
                ) ? (
                <>
                  <div className="all-modal-content">
                    {Array.isArray(memory?.answers?.lesson) &&
                      memory.answers.lesson.length > 0 && (
                        <div className="memory-content">
                          <h6 className="section-title">Your Lesson</h6>
                          <ul>
                            {memory.answers.lesson.map((item, idx) => (
                              <li className="text-body-b2" key={idx}>
                                {parse(item.text)}
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                    {Array.isArray(memory?.answers?.story) &&
                      memory.answers.story.length > 0 && (
                        <div className="story-section">
                          <h6 className="section-title">Your Story</h6>
                          <ul>
                            {memory.answers.story.map((item, idx) => (
                              <li className="text-body-b2" key={idx}>
                                {parse(item.text)}
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                    {Array.isArray(memory?.answers?.revelation) &&
                      memory.answers.revelation.length > 0 && (
                        <div className="revelation-section">
                          <h6 className="section-title">Your Revelation</h6>
                          {memory.answers.revelation.map((item, idx) => {
                            const content = parse(item.text);
                            const isParagraphWrapped = /<p[\s>]/.test(
                              item.text,
                            );
                            return isParagraphWrapped ? (
                              <React.Fragment key={idx}>
                                {content}
                              </React.Fragment>
                            ) : (
                              <p className="text-body-b2" key={idx}>
                                {content}
                              </p>
                            );
                          })}
                        </div>
                      )}
                    {Array.isArray(memory?.answers?.action) &&
                      memory.answers.action.length > 0 && (
                        <div className="action-section">
                          <h6 className="section-title">Your Action</h6>
                          {memory.answers.action.map((item, idx) => {
                            const content = parse(item.text);
                            const isParagraphWrapped = /<p[\s>]/.test(
                              item.text,
                            );
                            return isParagraphWrapped ? (
                              <React.Fragment key={idx}>
                                {content}
                              </React.Fragment>
                            ) : (
                              <p className="text-body-b2" key={idx}>
                                {content}
                              </p>
                            );
                          })}
                        </div>
                      )}
                  </div>
                  <div className="d-flex flex-column justify-content-between align-items-center gap-3 mt-3">
                    <button
                      className="full-mem-btn btn-3 btn-1-basic"
                      onClick={openFullMemoryModal}
                      style={{ maxWidth: "192px", width: "100%" }}
                    >
                      Full Memory
                    </button>
                    <button
                      className="btn-2 btn-1-primary"
                      onClick={handleGenerateAndShare}
                      style={{ maxWidth: "192px", width: "100%" }}
                    >
                      Share
                    </button>
                  </div>
                </>
              ) : (
                <p className="text-body-b2 text-center pt-3">
                  No memory available.
                </p>
              )}
            </div>
          </div>
        </BaseModal>
      )}
      {/* {isFullMemoryModalOpen && (
        <ShareDocumentModal show={isFullMemoryModalOpen} title={titleToShare} file={fileToShare} content={contentToShare} onClose={handleFullMemoryCloseShareModal} />
      )} */}

      {showJournalShareModal && (
        <JournalShareModal
          show={showJournalShareModal}
          title={titleToShare}
          onClose={handleJournalShareModalClose}
          journalId={memory?.user_journal_id}
        />
      )}
    </>
  );
};

export default ViewMemoryModal;
